var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pe-3 mb-md-5 mb-4"},[_c('div',[_c('b-skeleton-img',{attrs:{"aspect":"8:9"}})],1),_c('div',{staticClass:"mt-2 d-flex"},[_c('div',{staticClass:"col-7"},[_c('b-skeleton'),_c('b-skeleton',{staticClass:"me-5"})],1),_c('div',{staticClass:"col-4 ms-auto"},[_c('b-skeleton'),_c('b-skeleton')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }